const style = {
  fieldImage: {
    display: 'flex',
    alignItems: 'center'
  },
  smallIcon: {
    width: 18,
    height: 18
  },
  rightIcon: {
    marginLeft: 'auto'
  },
  imageNameText: {
    fontSize: 12,
    marginLeft: 15,
    maxWidth: 150,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'inline-block'
  }
};

export default style;



// WEBPACK FOOTER //
// ./src/components/FieldImage/style.js